"use client";

import * as React from "react";
import { Area, AreaChart, CartesianGrid, XAxis } from "recharts";
import { TrendingUp, Trophy, Users, Activity } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const chartData = [{
  month: "Jan",
  performance: 186
}, {
  month: "Feb",
  performance: 305
}, {
  month: "Mar",
  performance: 237
}, {
  month: "Apr",
  performance: 473
}, {
  month: "May",
  performance: 509
}, {
  month: "Jun",
  performance: 614
}];
const chartConfig = {
  performance: {
    label: "Performance",
    color: "hsl(var(--primary))"
  }
} satisfies ChartConfig;
const rankingsData = [{
  rank: 1,
  name: "Taller Mecánico",
  points: 2450,
  trend: "up"
}, {
  rank: 2,
  name: "Carpintería J.",
  points: 2380,
  trend: "stable"
}, {
  rank: 3,
  name: "Carnicería Real",
  points: 2100,
  trend: "down"
}];
const carouselImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611697/img/tennis_action_serve.png",
  alt: "Website design for local carpentry business"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611697/img/tennis_community_handshake.png",
  alt: "Google Maps optimization for local shops"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611697/img/tennis_crowd_cheering.png",
  alt: "Customer acquisition dashboard for agencies"
}];
export default function About() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}